export const headingsTable = [
  { label: 'Nombre de equipo', name: 'name', id: 0, sort: true },
  { label: 'Label', name: 'label', id: 1, sort: true },
  { label: 'Estado de la república', name: 'mex_state', id: 2, sort: true },
  { label: 'Acciones', name: 'actions', id: 4, sort: false },
];
